module.exports = __webpack_public_path__ + "static/media/Slider_125Jahre.49929975.jpg";